import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { CmpsDialogModule } from '@cmps/ng-uikit';

import { CmpsLazyI18nModule } from '../../../i18n/i18n.module';
import { epicObs } from '../../../store';
import { BehaviourLibraryService } from '../core';

import { BlDialogComponent } from './bl-dialog.component';
import { blDialogEpics } from './bl-dialog.epic';
import { TranslationIdMap } from './bl-dialog.i18n';
import { BlDialogService } from './bl-dialog.service';
import { DocumentComponent } from './component/document/document.component';

@NgModule({
    declarations: [BlDialogComponent, DocumentComponent],
    imports: [
        CmpsDialogModule,
        CmpsLazyI18nModule.forChild(TranslationIdMap),
        CommonModule,
    ],
    providers: [BehaviourLibraryService, BlDialogService],
})
export class CmpsCoachingBlDialogModule {
    constructor() {
        blDialogEpics.forEach((e) => epicObs.next(e));
    }
}
